import { Plug, Sliders, Send, TrendingUp } from "lucide-react";

const STEPS = [
  {
    icon: Plug,
    title: "Connect in 3 minutes",
    body: "Connect Square Appointments in three minutes and your bookings sync automatically. Using Vagaro, Fresha, Mindbody, Acuity, or Calendly? Add customers by hand today and get notified the moment we ship those integrations.",
  },
  {
    icon: Sliders,
    title: "Choose your voice",
    body: "Pick a tone — warm, playful, quiet, professional. Set your rebook cadence per service. Approve messages or run on auto.",
  },
  {
    icon: Send,
    title: "Follow-ups run themselves",
    body: "Thank-yous go out within minutes of a visit. Reviews at the sweet spot. Rebooking nudges timed to each customer's rhythm.",
  },
  {
    icon: TrendingUp,
    title: "Watch bookings compound",
    body: "See recovered revenue, review growth, and rebooking lift in one clean dashboard. Adjust with a click, or don't.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="py-24 sm:py-32 bg-[#EFECE5]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="max-w-2xl mb-16">
          <div className="overline mb-4">How it works</div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#183D36]">
            Set it up once. It quietly earns you visits from then on.
          </h2>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-[#183D36]/15" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {STEPS.map((step, i) => {
              const Icon = step.icon;
              return (
                <div key={step.title} className="relative" data-testid={`how-step-${i+1}`}>
                  <div className="relative w-20 h-20 rounded-full bg-[#FAF7F0] border border-[#183D36]/15 flex items-center justify-center mb-6 shadow-sm">
                    <Icon size={22} strokeWidth={1.75} className="text-[#183D36]" />
                    <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#F4B183] text-[#183D36] text-sm font-heading font-semibold flex items-center justify-center">
                      {i + 1}
                    </span>
                  </div>
                  <h3 className="font-heading text-xl text-[#183D36] mb-2">{step.title}</h3>
                  <p className="text-[#4A4A4A] leading-relaxed">{step.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
